/* RCC gold dust — the same magic-dust language as the Keeper's Top Shelf ember stream,
   drifting through item sections site-wide. Attaches a particle canvas to any element
   carrying [data-rcc-dust] (plus Dawn's collection-list wrapper on the homepage).
   Replaces the rejected "glare sweep" (Jefe 2026-07-10: dust yes, sheen no). */
(function () {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function attach(host) {
    if (host.dataset.rccDustAttached) return;
    host.dataset.rccDustAttached = '1';
    var cv = document.createElement('canvas');
    cv.style.cssText = 'position:absolute;inset:0;pointer-events:none;z-index:3;';
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.appendChild(cv);
    var cx = cv.getContext('2d');
    var parts = [];

    function fit() {
      var r = host.getBoundingClientRect();
      cv.width = Math.round(r.width);
      cv.height = Math.round(r.height);
    }
    addEventListener('resize', fit);
    fit();

    // density scales with area; slow constant drift right-to-left with gentle fall
    function spawn(kind) {
      var y = cv.height * (0.05 + Math.random() * 0.75);
      if (kind === 'ember') parts.push({ k: 'e', x: cv.width + 10, y: y, vx: -(0.35 + Math.random() * 0.5), vy: 0.02 + Math.random() * 0.05, r: 1.3 + Math.random() * 2.0, a: 0, max: 0.5 + Math.random() * 0.25, life: 0, span: 10000 + Math.random() * 6000, sway: Math.random() * 6.28 });
      else parts.push({ k: 'g', x: Math.random() * cv.width, y: y, vx: -0.08, vy: 0, r: 2.6 + Math.random() * 2.4, a: 0, max: 0.85, life: 0, span: 800 + Math.random() * 500, sway: 0 });
    }

    var last = performance.now(), acc = 0;
    var interval = Math.max(210, 90000 / Math.max(cv.width, 600)); // wider sections = denser
    function tick(now) {
      if (cv.width < 200) { requestAnimationFrame(tick); return; }
      var dt = Math.min(50, now - last); last = now;
      acc += dt;
      if (acc > interval) { acc = 0; spawn('ember'); if (Math.random() < 0.16) spawn('glint'); }
      cx.clearRect(0, 0, cv.width, cv.height);
      parts = parts.filter(function (p) { return (p.life += dt) < p.span && p.x > -40; });
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        var t = p.life / p.span;
        p.a = p.max * (t < 0.1 ? t / 0.1 : 1 - (t - 0.1) / 0.9);
        p.x += p.vx * dt * 0.06;
        p.y += p.vy * dt * 0.06 + Math.sin(now / 1100 + p.sway) * 0.1;
        if (p.k === 'e') {
          var g = cx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 3);
          g.addColorStop(0, 'rgba(228,189,104,' + p.a + ')');
          g.addColorStop(0.5, 'rgba(196,151,59,' + p.a * 0.5 + ')');
          g.addColorStop(1, 'rgba(196,151,59,0)');
          cx.fillStyle = g; cx.beginPath(); cx.arc(p.x, p.y, p.r * 3, 0, 6.29); cx.fill();
        } else {
          cx.strokeStyle = 'rgba(236,228,210,' + p.a + ')'; cx.lineWidth = 1;
          var s = p.r * (1 - t * 0.4);
          cx.beginPath();
          cx.moveTo(p.x - s, p.y); cx.lineTo(p.x + s, p.y);
          cx.moveTo(p.x, p.y - s); cx.lineTo(p.x, p.y + s);
          cx.stroke();
        }
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function init() {
    var hosts = document.querySelectorAll('[data-rcc-dust], .collection-list-wrapper');
    for (var i = 0; i < hosts.length; i++) attach(hosts[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
